import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { UserService } from './user.service';
import { ModalController } from '@ionic/angular';
import { Account } from 'src/models/account';
import { AccountDocument, DocumentType } from 'src/models/account-document';
import { OrganizationRequiredDocument, DocumentRequiredOn } from 'src/models/organization-required-document';
import { MediaService } from './media.service';
import { Browser } from '@capacitor/browser';
import { SearchDocumentsRequest } from 'src/models/account-document';
import { SecureDocumentsComponent } from 'src/app/shared-components/secure-documents/secure-documents.component';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    constructor(
        private api: ApiService,
        private userService: UserService,
        private modalCtrl: ModalController,
        private mediaService: MediaService
    ) { }

    async getRequiredDocumentsForOrgs(ids: number[]): Promise<OrganizationRequiredDocument[]> {
        return this.api.postWithAuth<OrganizationRequiredDocument[]>(
          this.api.endpoints.documents + '/getRequiredDocumentsForOrgs',
          ids
        );
    }

    async getAccountsDocuments(ids: number[]): Promise<AccountDocument[]> {
        return this.api.postWithAuth<AccountDocument[]>(
          `${this.api.endpoints.documents}/getAccountsDocuments`,
          ids
        );
    }

    async getMissingAccountDocuments(accountId: number, orgIds: number[]): Promise<AccountDocument[]> {
        return this.api.postWithAuth<AccountDocument[]>(
          `${this.api.endpoints.documents}/getMissingAccountDocuments?accountId=${accountId}`,
          orgIds
        );
    }

    async addAccountDocument(accountDoc: AccountDocument): Promise<AccountDocument> {
        return this.api.postWithAuth<AccountDocument>(
          `${this.api.endpoints.documents}/addAccountDocument`,
          accountDoc
        );
    }

    async updateAccountDocument(accountDoc: AccountDocument): Promise<AccountDocument> {
        return this.api.postWithAuth<AccountDocument>(
          `${this.api.endpoints.documents}/updateAccountDocument`,
          accountDoc
        );
    }

    async getRequiredDocument(id: number) {
        return this.api.getWithAuth<OrganizationRequiredDocument>(
            `${this.api.endpoints.documents}/GetRequiredDocument?id=${id}`,
        );
    }

    async generateAllAccountsDocuments(filters: SearchDocumentsRequest){
        return this.api.postWithAuth<AccountDocument[]>(
            `${this.api.endpoints.documents}/generateAllAccountsDocuments`,
            filters
        );
    }

    async downloadDocument(doc: AccountDocument, country: string = undefined) {
        let url;
        if (doc.documentType === DocumentType.TaxDocument) {
            url = country === 'United States' ? 'https://www.irs.gov/pub/irs-pdf/fw9.pdf' : 'https://www.irs.gov/pub/irs-pdf/fw8ben.pdf';
        } else {
            url = doc.organizationRequiredDocument.url;
        }
  
        await Browser.open({ url });
    }

    async handleAccountDocUpload(document: AccountDocument, accountId: number, orgName?: string, requiredDocName?: string) {
        const selectedBtn = await this.mediaService.presentUploadOptions();

        if (!selectedBtn.role || selectedBtn.role === 'cancel' || selectedBtn.role === 'backdrop') {
            return false;
        }

        if (!requiredDocName && (document.documentType !== undefined)) {
            if (document.documentType === DocumentType.TaxDocument) {
                requiredDocName = 'Tax Document';
            } else if (document.documentType === DocumentType.BirthCertificate) {
                requiredDocName = 'Birth Certificate';
            }
        }

        let fileName = this.mediaService.generateFileName(
            orgName,
            requiredDocName);


        if (selectedBtn.role === 'image') {
            fileName = await this.mediaService.handleImageUpload(fileName, accountId);
        } else {
            fileName = await this.mediaService.handlePdfUpload(fileName, accountId);
        }

        console.log('file name after select or cancel', fileName);
        if (fileName) {
            document.fileName = fileName;

            if (document.id === 0) {
                await this.addAccountDocument(document);
            } else {
                await this.updateAccountDocument(document);
            }
            return true;
        }
        return false;
    }

}
